import { Box, Flex, Link, Text } from '@chakra-ui/react';

import Icon from '@/components/Icon';
import { LinkOption } from '@/customtypes/global';
import { ChervonRight } from '@/icons';
import { IconBackgroundContainer } from '@/themes';
import { getBlockChainIcon } from '@/utils/globalCommon';

interface GovernanceProps {
  governanceData: LinkOption[];
  onClick(key: string): void;
}

const Governance = ({ governanceData, onClick }: GovernanceProps) => {
  return (
    <>
      <Text
        fontWeight="700"
        fontSize="10px"
        lineHeight="16px"
        letterSpacing="0.5px"
      >
        GOVERNANCE
      </Text>
      {governanceData.map((data) => (
        <Box
          cursor="pointer"
          onClick={() => onClick(data.key)}
          key={data.key}
          h="24px"
          mt="1rem"
          w="100%"
        >
          <Link href={data.link ?? undefined} rel="canonical" cursor="pointer">
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center">
                <IconBackgroundContainer
                  h="24px"
                  w="24px"
                  color="textSecondary"
                  bg="backgroundSecondary"
                >
                  <Icon
                    Icon={getBlockChainIcon(data.key)}
                    width="14px"
                    height="14px"
                  />
                </IconBackgroundContainer>
                <Text
                  ml="0.5rem"
                  fontWeight="500"
                  fontSize="12px"
                  color="textPrimary"
                  _hover={{
                    color: 'textSecondary',
                  }}
                >
                  {data.title}
                </Text>
              </Flex>
              <Box
                color="primary"
                _dark={{
                  color: 'textPrimary',
                }}
              >
                <Icon width="24px" height="24px" Icon={ChervonRight} />
              </Box>
            </Flex>
          </Link>
        </Box>
      ))}
    </>
  );
};

export default Governance;
